import { FormControlLabel, Stack, Switch, TextField } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IPartnerContactFormValues } from "src/entities/partners/model/types";

export const OtherInfo: FC = () => {
  const { control } = useFormContext<IPartnerContactFormValues>();

  return (
    <Stack spacing={4}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Controller
          control={control}
          name="feedback_call_consent"
          render={({ field }) => (
            <FormControlLabel
              control={<Switch {...field} checked={!!field.value} />}
              label="QA обзвон"
            />
          )}
        />
        <Controller
          control={control}
          name="is_decision_maker"
          render={({ field }) => (
            <FormControlLabel
              control={<Switch {...field} checked={!!field.value} />}
              label="ЛПР"
            />
          )}
        />
        <Controller
          control={control}
          name="email_marketing_consent"
          render={({ field }) => (
            <FormControlLabel
              control={<Switch {...field} checked={!!field.value} />}
              label="Рассылка"
            />
          )}
        />
      </Stack>
      <Controller
        control={control}
        name="note"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="Примечание"
            error={!!error}
            helperText={error?.message}
            multiline
            rows={3}
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },
            }}
          />
        )}
      />
    </Stack>
  );
};
